import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '../ui/table';
import { CalendarDays } from 'lucide-react';
import { AttendanceRow } from './AttendanceRow';

export const AttendanceTab = ({ sessions, project, onSave }) => (
  <Card>
    <CardHeader>
      <CardTitle>Attendance Tracking</CardTitle>
      <CardDescription>Track expected and actual attendees per session</CardDescription>
    </CardHeader>
    <CardContent>
      {sessions.length > 0 ? (
        <div className="space-y-4">
          <Table data-testid="attendance-table">
            <TableHeader>
              <TableRow>
                <TableHead>SESSION</TableHead>
                <TableHead>DATE</TableHead>
                <TableHead>STATUS</TableHead>
                <TableHead className="text-right">EXPECTED</TableHead>
                <TableHead className="text-right">REGISTERED</TableHead>
                <TableHead className="text-right">ACTUAL</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sessions.map(session => (
                <AttendanceRow key={session.id} session={session} onSave={onSave} />
              ))}
            </TableBody>
          </Table>
          <div className="grid grid-cols-3 gap-4 pt-2 border-t">
            <div className="text-center p-4 border rounded-lg">
              <p className="text-sm text-muted-foreground mb-1">Total Expected</p>
              <p className="text-2xl font-bold font-heading">
                {sessions.reduce((sum, s) => sum + (s.expected_count || 0), 0) || project.expected_attendees || 0}
              </p>
            </div>
            <div className="text-center p-4 border rounded-lg">
              <p className="text-sm text-muted-foreground mb-1">Total Registered</p>
              <p className="text-2xl font-bold font-heading text-blue-600">
                {sessions.reduce((sum, s) => sum + (s.registered_count || 0), 0) || project.registered_attendees || 0}
              </p>
            </div>
            <div className="text-center p-4 border rounded-lg">
              <p className="text-sm text-muted-foreground mb-1">Total Actual</p>
              <p className="text-2xl font-bold font-heading text-green-600">
                {sessions.reduce((sum, s) => sum + (s.attended_count || 0), 0) || project.actual_attendees || 0}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-muted-foreground">
          <CalendarDays className="w-10 h-10 mx-auto mb-3 opacity-40" />
          <p>No sessions yet. Add sessions to track attendance.</p>
        </div>
      )}
    </CardContent>
  </Card>
);

export default AttendanceTab;
